<template>
  <v-flex>
    <v-data-table
      v-model="vatProducts"
      :loading="loading"
      :headers="headers"
      :items="products"
      :rows-per-page-text="$t('Rows per page')"
      :pagination.sync="pagination"
      :total-items="total"
      show-select
      select-all
      class="elevation-1"
      item-key="id"
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      />

      <template v-slot:items="props">
        <settings-vat-product-row
          :props="props"
        />
      </template>
      <template v-slot:pageText="props">
        <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import ProductService from '@/modules/Products/service.js'
import TaxonomyProductDataTableRow from '@/modules/Products/components/TaxonomyProductDataTableRow'
import SettingsVatProductRow from '@/modules/Settings/components/Taxes/SettingsVatProductRow'

export default {
  name: 'SettingsVatProducts',
  components: { SettingsVatProductRow, TaxonomyProductDataTableRow },
  props: {
    vat: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      total: 0,
      loading: false,
      products: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('SKU'), value: 'sku' },
        { text: this.$t('Name'), value: 'name' }
      ]
    },
    vatProducts: {
      get: function () {
        return this.products.filter(product => this.vat.product_ids.includes(product.id))
      },
      set: function (products) {
        this.vat.product_ids = products.map(product => product.id)
      }
    }
  },

  watch: {
    pagination: function () {
      this.getProducts()
    }
  },

  methods: {
    async getProducts () {
      this.loading = true
      const res = await ProductService.loadOnlyProducts(this.pagination)
      this.products = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
